import { Link } from 'react-router-dom';

const NotFoundPage = () => {

  return (
    <div className="min-h-screen bg-[#fcfdfe] flex flex-col items-center justify-center px-4 md:px-6 py-8 md:py-12 relative overflow-hidden" style={{
      backgroundImage: 'radial-gradient(circle, rgba(42,75,124,0.08) 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }}>
      {/* Background Blur Circles */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#0bb9d0]/5 rounded-full blur-[120px] -z-10"></div>
      <div className="absolute top-1/3 left-1/3 -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] bg-[#00b587]/5 rounded-full blur-[100px] -z-10"></div>

      <div className="max-w-[800px] w-full text-center flex flex-col items-center gap-6 md:gap-8">
        {/* System Status Card */}
        <div className="relative w-full max-w-[400px] md:max-w-[480px] aspect-[4/3] flex items-center justify-center p-3 md:p-4">
          <div className="w-full h-full bg-white border border-gray-100 rounded-2xl md:rounded-3xl overflow-hidden relative flex items-center justify-center" style={{
            boxShadow: '0 20px 50px rgba(0,0,0,0.05)'
          }}>
            <div className="absolute inset-0 bg-gradient-to-br from-[#0bb9d0]/5 to-[#00b587]/5"></div>
            <div className="relative flex flex-col items-center justify-center gap-6">
              {/* Pipeline Visualization */}
              <div className="flex gap-4">
                <div className="w-16 h-4 bg-[#0bb9d0]/10 rounded-full"></div>
                <div className="w-16 h-4 bg-[#0bb9d0] rounded-full" style={{
                  boxShadow: '0 0 15px rgba(11,185,208,0.4)'
                }}></div>
                <div className="w-16 h-4 bg-white rounded-full border border-dashed border-[#0bb9d0]/40"></div>
              </div>
              <div className="w-48 h-1 bg-gray-200 relative">
                <div className="absolute -right-2 -top-2 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center shadow-lg">
                  <i className="ri-close-line text-[12px] text-white font-bold"></i>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="w-16 h-4 bg-white rounded-full border border-dashed border-[#00b587]/40"></div>
                <div className="w-16 h-4 bg-[#00b587]/30 rounded-full"></div>
                <div className="w-16 h-4 bg-[#00b587]/10 rounded-full"></div>
              </div>
              <div className="absolute -bottom-6 text-[10px] font-mono text-[#2a4b7c]/30 uppercase" style={{ letterSpacing: '0.25em' }}>
                System Status: Interrupted
              </div>
            </div>
          </div>
        </div>

        {/* 404 Heading */}
        <div className="flex flex-col items-center -mt-2 md:-mt-4">
          <h1 className="text-[#2a4b7c] text-7xl md:text-8xl lg:text-[140px] font-black leading-none" style={{ letterSpacing: '-0.02em' }}>
            404
          </h1>
          <div className="h-1.5 w-24 bg-gradient-to-r from-[#0bb9d0] to-[#00b587] rounded-full mt-2"></div>
        </div>

        {/* Content */}
        <div className="flex flex-col gap-3 md:gap-4 max-w-[600px] px-4">
          <h2 className="text-[#2a4b7c] text-2xl md:text-3xl lg:text-4xl font-extrabold" style={{ letterSpacing: '-0.01em' }}>
            Trang này hiện chưa được triển khai
          </h2>
          <p className="text-[#64748b] text-base md:text-lg leading-relaxed">
            Có vẻ như đường dẫn này nằm ngoài pipeline của chúng tôi. <br className="hidden md:block"/>
            Hãy để <span className="text-[#2a4b7c] font-bold">StackWay</span> đưa bạn trở lại lộ trình an toàn.
          </p>
        </div>

        {/* Action Button */}
        <div className="mt-2 md:mt-4">
          <Link
            to="/"
            className="group inline-flex items-center justify-center px-10 py-4 text-sm font-bold text-white rounded-xl bg-[#00c897] transition-all hover:scale-[1.02] active:scale-95 gap-2 cursor-pointer hover:bg-[#00b587]"
            style={{
              boxShadow: '0 10px 15px -3px rgba(0, 200, 151, 0.3), 0 4px 6px -4px rgba(0, 200, 151, 0.2)'
            }}
          >
            <i className="ri-home-line text-[20px]"></i>
            Về Trang Chủ
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
